/**
 * Created by mateimisarca on 24.03.2021
 */

import ResultsAdminPage from './results-admin-page';

export default ResultsAdminPage;
